import {
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { isValidPhoneNumber } from "react-phone-number-input";
import { PatternFormat } from "react-number-format";
import { useForm, Controller } from "react-hook-form";
import BootstrapForm from "react-bootstrap/Form";
import axios from "axios";
import "./index.scss";
import toast from "react-hot-toast";
import plus from "../../../../assets/images/+.png";

const ContactForm = () => {
  const {
    control,
    handleSubmit,
    register,
    reset,
    clearErrors,
    setError,
    unregister,
    getValues,
    getFieldState,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "all",
  });

  const submitForm = (data) => {
    console.log(data);
    axios.defaults.headers["X-Api-Token"] =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6Ikp6XVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIi5wibmFtZSI6Ikpva2G4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c";
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["Access-Control-Allow-Credentials"] = "true";

    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("surname", data.surname);
    formData.append("email", data.email);
    formData.append("phone", data.phone);
    formData.append("message", data.message);

    axios
      .post(
        "https://api.webeyondcreative.com/api/form/store/we_careerplus202211_email",
        formData
      )
      .then((response) => {
        if (response.data.exists === "success") {
          toast.success(
            "Your message has been sent. Thank you for your attention."
          );
          reset();
        } else if (response.data.exists === "db_error") {
          toast.error("Your message hasn't been sent!");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className="contact-form-section">
      <Container className="position-relative">
        <img className="plus" src={plus} alt="plus" />
        <Row className="d-flex flex-column">
          <Col>
            <h3 className="title">CONTACT US</h3>
            <div className="contact-information">
              <div className="phone">
                <h5 className="subtitle">PHONE</h5>
                <p>0 (212) 211 11 93 - 94</p>
              </div>
              <div className="email">
                <h5 className="subtitle">E-MAIL</h5>
                <a href="mailto:info@careerplus.org">info@careerplus.org</a>
              </div>
            </div>
          </Col>
          <Col sm="12" md="8" lg="8">
            <Form onSubmit={handleSubmit(submitForm)}>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <BootstrapForm.Control
                      isInvalid={!!errors.name}
                      placeholder="Name"
                      {...register("name", {
                        required: "This field is required!",
                      })}
                    />
                    <FormFeedback>{errors.name?.message}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <BootstrapForm.Control
                      isInvalid={!!errors.surname}
                      {...register("surname", {
                        required: "This field is required!",
                      })}
                      placeholder="Surname"
                    />
                    <FormFeedback>{errors.surname?.message}</FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <BootstrapForm.Control
                      isInvalid={!!errors.email}
                      {...register("email", {
                        required: "This field is required!",
                      })}
                      placeholder="E-mail"
                    />
                    <FormFeedback>{errors.email?.message}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <Controller
                    control={control}
                    name="phone"
                    rules={{
                      required: "Please enter your phone number",
                      validate: (value) =>
                        isValidPhoneNumber(value) ||
                        "The phone number is invalid",
                    }}
                    render={({
                      field: { onChange, onBlur, value, name, ref },
                      fieldState: { error },
                    }) => (
                      <FormGroup>
                        <PatternFormat
                          name={name}
                          getInputRef={ref}
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          disabled={isSubmitting}
                          customInput={BootstrapForm.Control}
                          isInvalid={!!error}
                          placeholder="Phone"
                          format="+90 ### ### ## ##"
                          mask="_"
                        />
                        <FormFeedback>{error && error.message}</FormFeedback>
                      </FormGroup>
                    )}
                  />
                </Col>
              </Row>
              <FormGroup>
                <BootstrapForm.Control
                  className="textarea"
                  isInvalid={!!errors.message}
                  {...register("message", {
                    required: "This field is required!",
                  })}
                  as="textarea"
                  placeholder="Message"
                />
                <FormFeedback>{errors.message?.message}</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Button type="submit">Send</Button>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactForm;
